import { LmIconFilledMiscOrganization } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconCultureOfflineEventsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconFilledMiscOrganization {...rest} /> : <LmIconFilledMiscOrganization {...rest} />;

export default IconCultureOfflineEventsCommon;
